import { Box } from '@mui/material';

export const DyTabPanel = ({
  activeTab,
  tabValue,
  children,
}: {
  activeTab: string;
  tabValue: string;
  children?: React.ReactNode;
}) => {
  return (
    <div role="tabpanel" hidden={tabValue !== activeTab}>
      {tabValue === activeTab && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
};
